module.exports = __webpack_public_path__ + "static/img/proImg6.0e87dac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/proImg6.png
// module id = pJBf
// module chunks = 1